module.exports = __webpack_public_path__ + "static/media/logo_wbs_schulen.a98294aa.svg";